export const structureTypesMapping = {
  "0000": [null, [1], 26, null],
  "0041": [null, [1], 21, null],
  "0100": [null, [1], 26, null],
  "0200": [null, [1], 24, null],
  "0300": [null, [1, 2], 19, null],
  "0310": [null, [1, 2], 19, null],
  "0400": [null, [1], 21, null],
  "0500": [null, [1], 21, null],
  "0600": [null, [1], 74, null],
  "0691": [null, [1, 2], 19, null],
  "0700": [null, [2], 56, null],
  "0800": [null, [1], 27, null],
  "0810": [null, [1], 27, null],
  "0991": [null, [1, 2], 19, null],
  "0994": [null, [1], 21, null],
  1000: [null, [2], 15, null],
  1001: [null, [2], 9, null],
  1040: [null, [2], 58, null],
  1140: [null, [2], 15, null],
  1191: [null, [2], 15, null],
  1192: [null, [2], 15, null],
  1193: [null, [2], 15, null],
  1194: [null, [2], 15, null],
  1196: [null, [2], 15, null],
  1200: [null, [2], 9, null],
  1210: [null, [2], 54, null],
  1295: [null, [2], 9, null],
  1391: [null, [2], 15, null],
  1392: [null, [2], 15, null],
  1393: [null, [2], 15, null],
  1491: [null, [2], 15, null],
  1492: [null, [2], 15, null],
  1493: [null, [2], 15, null],
  1494: [null, [2], 15, null],
  1500: [null, [2], 15, null],
  1642: [null, [2], 15, null],
  1691: [null, [2], 15, null],
  1692: [null, [2], 15, null],
  1700: [null, [2], 9, null],
  1740: [null, [2], 58, null],
  1742: [null, [2], 9, null],
  1800: [null, [2], 9, null],
  1840: [null, [2], 58, null],
  1910: [null, [2], 54, null],
  1940: [null, [2], 58, null],
  1942: [null, [2], 9, null],
  1991: [null, [2], 9, null],
  2000: [null, [2], 18, null],
  2191: [null, [2], 12, null],
  2192: [null, [2], 12, null],
  2200: [null, [2], 12, null],
  2300: [null, [2], 9, null],
  2591: [null, [2], 14, null],
  2592: [null, [2], 14, null],
  2691: [null, [2], 14, null],
  2692: [null, [2], 14, null],
  2693: [null, [2], 14, null],
  2694: [null, [2], 14, null],
  2791: [null, [2], 14, null],
  2792: [null, [2], 14, null],
  2793: [null, [2], 14, null],
  2794: [null, [2], 14, null],
  2891: [null, [2], 11, null],
  2892: [null, [2], 11, null],
  2893: [null, [1], 24, null],
  2900: [null, [2], 15, null],
  3000: [null, [2], 15, null],
  3100: [null, [2], 1, null],
  3200: [null, [2], 1, null],
  3300: [null, [2], 1, null],
  3400: [null, [2], 1, null],
  3500: [null, [2], 1, null],
  3600: [null, [2], 1, null],
  3700: [null, [2], 1, null],
  3800: [null, [2], 1, null],
  3940: [null, [2], 6, null],
  3991: [null, [2], 6, null],
  3992: [null, [2], 6, null],
  3993: [null, [2], 6, null],
  3994: [null, [2], 6, null],
  3995: [null, [2], 6, null],
  4000: [null, [2], 7, null],
  4001: [null, [2], 7, null],
  4040: [null, [2], 7, null],
  4100: [null, [2], 7, null],
  4200: [null, [2], 7, null],
  4300: [null, [2], 7, null],
  4400: [null, [2], 7, null],
  4500: [null, [2], 7, null],
  4600: [null, [2], 7, null],
  4700: [null, [2], 7, null],
  4800: [null, [2], 7, null],
  4840: [null, [2], 7, null],
  4842: [null, [2], 7, null],
  4891: [null, [2], 7, null],
  4892: [null, [2], 7, null],
  4893: [null, [2], 7, null],
  4894: [null, [2], 7, null],
  4895: [null, [2], 7, null],
  4897: [null, [2], 7, null],
  4898: [null, [2], 18, null],
  4899: [null, [2], 7, null],
  4900: [null, [2], 75, null],
  5000: [null, [2], 70, null],
  5100: [null, [2], 70, null],
  5200: [null, [2], 70, null],
  5300: [null, [2], 70, null],
  5400: [null, [2], 70, null],
  5500: [null, [2], 70, null],
  5600: [null, [2], 70, null],
  5700: [null, [2], 70, null],
  5800: [null, [2], 70, null],
  5900: [null, [2], 70, null],
  6000: [null, [2], 70, null],
  6100: [null, [2], 70, null],
  6200: [null, [2], 70, null],
  6300: [null, [2], 70, null],
  6400: [null, [2], 70, null],
  6500: [null, [2], 70, null],
  6600: [null, [2], 70, null],
  6700: [null, [2], 70, null],
  6800: [null, [2], 70, null],
  6900: [null, [2], 70, null],
  7000: [null, [2], 13, null],
  7100: [null, [2], 2, null],
  7200: [null, [2], 13, null],
  7300: [null, [2], 5, null],
  7400: [null, [1], 74, null],
  7500: [null, [2], 54, null],
  7691: [null, [2], 5, null],
  7692: [null, [2], 5, null],
  7693: [null, [2], 1, null],
  7700: [null, [2], 1, null],
  7800: [null, [1], 74, null],
  7900: [null, [2], 1, null],
  8000: [null, [2], 1, null],
  8100: [null, [2], 1, null],
  8200: [null, [2], 65, null],
  8300: [null, [2], 13, null],
  8400: [null, [2], 13, null],
  8500: [null, [2], 5, null],
  8600: [null, [2], 18, null],
  8700: [null, [2], 18, null],
  8800: [null, [2], 18, null],
  8900: [null, [2], 18, null],
  9000: [null, [2], 1, null],
  9100: [null, [2], 18, null],
  9200: [null, [2], 7, null],
  9300: [null, [2], 7, null],
  9400: [null, [2], 18, null],
  9500: [null, [2], 18, null],
  9600: [null, [1], 57, null],
  9700: [null, [1], 57, null],
  9800: [null, [2], 18, null],
  9900: [null, [1], 57, null],
  9999: [null, [2], 1, null],
};
